import React from 'react';
import { styled } from '@glitz/react';
import ArticleListViewModel from 'MagazineStart/ArticleListViewModel.type';
import ArticleListItemViewModel from 'Shared/ViewModels/ContentListItemViewModel.type';
import * as style from 'Shared/Style';
import GridRowContent from './GridRowContent';

const GridLayoutWrap = styled.div({
  rowGap: '40px',
  ['@media ' + style.mediaMinLarge]: {
    rowGap: '80px',
  },
})

const GridLayout = (props: { articleListViewModel: ArticleListViewModel; isCompact: boolean }) => {
  const { articleListViewModel, isCompact } = props;
  //group articles into rows of 3, or 1 per row if on mobile
  //in the future, this is where we might mix in content
  const rows = articleListViewModel.articles.reduce(
    (rows, key, index) =>
      (index % (isCompact ? 1 : 3) == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows,
    [],
  );

  return (
    <GridLayoutWrap>
      {rows.map((articles, index) => (
        <GridRowContent
          key={index}
          articles={articles as ArticleListItemViewModel[]}
          listContent={articleListViewModel.listContentItems?.find(
            (x) => index === (isCompact ? x.mobileIndex : x.desktopIndex),
          )}
          isCompact={isCompact}
        />
      ))}
    </GridLayoutWrap>
  );
};

export default GridLayout;